import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  signal,
} from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'acl-error-modal',
  standalone: false,
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModalComponent {
  private readonly modalController = inject(ModalController);
  readonly _title = signal<string>('');
  readonly _message = signal<string>('');

  @Input() set title(value: string) {
    this._title.set(value);
  }
  @Input() set message(value: string) {
    this._message.set(value);
  }

  dismissModal(): void {
    this.modalController.dismiss();
  }
}
